import BreadcrumbSection from "~/layout/public/bread-crumbs/bread-crumb-section"
import ContactSection from "~/components/pages/contact/contact-section";
import { createSignedFormRef } from "~/utils/form-signing";
import { canonical, getTitleTemplate } from "~/utils/meta";
import type { Route } from "./+types/contact";
import { defaultMeta, mergeMeta } from "~/lib/meta";

export async function loader() {
    const formRef = "contact-us";           // page-specific
    const formSig = createSignedFormRef(formRef, process.env.FORM_TIMEOUT ? Number(process.env.FORM_TIMEOUT) : 1800); // 30 minute expiry
    return { formRef, formSig };
}
const bcTitle = 'Engaging and Impactful Training Across England and Wales'
const bcText = 'Constellation Training delivers concise, memorable, and engaging courses nationwide. Contact us by phone or email to discuss your training needs.'
const description = "Constellation Training has a range of online training courses designed to meet the needs of various industries and professionals.";
const url = '/contact';

export default function ContactPage() {



    return (
        <main id="main">
            <BreadcrumbSection title={bcTitle} text={bcText} />
            <ContactSection />
        </main>

    )
}

export function meta({ matches }: Route.MetaArgs) {
    const tpl = getTitleTemplate(matches);
    const pageTitle = "Contact Us - First Aid & MHFA Training";
    const title = tpl(pageTitle);
    const desc = description;
    return mergeMeta(
        defaultMeta(),
        [
            { title: title },
            { name: "description", content: desc },
            { property: "og:title", content: title },
            { property: "og:description", content: desc },
            { property: "og:url", content: canonical(url) },
            { name: "twitter:title", content: title },
            { name: "twitter:description", content: desc },
            { tagName: "link", rel: "canonical", href: canonical(url) },
            // add canonical as a <link> via your links() export separately
        ]
    );
}